import {
  IVideoMetadataStreamingPlaylist,
  UserHistory,
} from '../../interface/videoMetadataResponse';
import { ContactDetails, IshortVideo, MediaAttachment, Realm } from '../../store/interface';

export interface IProfileDetails {
  user: IQnAUser;
  realm: Realm;
}

export interface RealmBusinessProfile {
  businessScoreVisibility: boolean;
  businessName: string;
  id: string;
  qrEnabled: boolean;
  verificationStatus: boolean;
  paymentAssured: boolean;
  businessScoreAvailability: boolean;
  politicallyExposed: boolean;
  businessPremiseVisited: boolean;
  ediEnabled: boolean;
}

export interface IQnAUser {
  updatedByTool: string;
  createdByTool: string;
  id: string;
  osUpdatedAt: Date;
  politicallyExposed: boolean;
  verified: boolean;
  primaryPhoneNumber: string;
  osCreatedAt: Date;
  primaryRealm: string;
  isBlackListed: boolean;
  cpv: any[];
  userType: any[];
  additionalDetails: any[];
  investmentDetails: any[];
  contactDetails: ContactDetails;
  mediaDetails: MediaDetails;
  businessProfile: UserBusinessProfile;
}

export interface UserBusinessProfile {
  businessName: string;
}

export interface MediaDetails {
  id: string;
  media: Media[];
  type: string;
}

export interface Media {
  mediaUrl: string;
  type: string;
  key: string;
  name: string;
  visibility: string;
}



export interface IShortsFeed {
  count: number;
  data: IshortVideo[];
  message: string;
  next: string;
  offset: number;
  statusCode: number;
}

export interface IFeedLongVideoData {
  avatar: string;
  created_at: Date;
  id: string;
  likes_count: number;
  liked: boolean;
  comments_count: number;
  name: string;
  type: string;
  media_attachments: MediaAttachment[];
  tags: Tag[];
  description: string;
  url: string;
  videoId: string;
  thumbnail: string;
  cardType: 'long';
  text: string;
  streamingPlaylists: IVideoMetadataStreamingPlaylist[];
  card?: {
    url: string;
    title: string;
    description: string;
    type: string;
    author_name: string;
    author_url: string;
    provider_name: string;
    provider_url: string;
    html: string;
    width: number;
    height: number;
    image: string;
  };
}

export interface Tag {
  name: string;
  url: string;
}
export interface StreamingPlaylist {
  files: string[];
  id: number;
  playlistURL: string;
  redundancies: string[];
  segmentsSha256URL: string;
  type: number;
}

export interface IprefferedStreamResolution{
  label:string;
  id:string;
}




export interface IExchangeTokenResponse {
  statusCode: number;
  message: string;
  data: IExchangeTokenData;
}

export interface IExchangeTokenData {
  mastodonToken: string;
  peerTube: IStreamData;
  qnaUser: IQnaUser;
}

export interface IStreamData {
  token_type: string;
  access_token: string;
  refresh_token: string;
  expires_in: number;
  refresh_token_expires_in: number;
  lastTokenGeneratedAt?: number;
}

export interface IQnaUser {
  originalName: string;
  originalPicture: null;
  lastseen: number;
  location: string;
  latlng: null;
  status: string;
  aboutme: string;
  badges: string;
  groups: string;
  upvotes: number;
  downvotes: number;
  comments: number;
  picture: string;
  website: string;
  favtags: any[];
  favspaces: any[];
  modspaces: any[];
  expertspaces: any[];
  spaces: string[];
  replyEmailsEnabled: boolean;
  commentEmailsEnabled: boolean;
  favtagsEmailsEnabled: boolean;
  anonymityEnabled: boolean;
  darkmodeEnabled: boolean;
  yearlyVotes: number;
  quarterlyVotes: number;
  monthlyVotes: number;
  weeklyVotes: number;
  customBadges: any[];
  pendingEmail: null;
  editorRoleEnabled: boolean;
  id: string;
  timestamp: number;
  type: string;
  appid: string;
  parentid: null;
  creatorid: string;
  updated: number;
  name: string;
  tags: any[];
  votes: number;
  version: number;
  stored: boolean;
  indexed: boolean;
  cached: boolean;
  properties: IQnAProps;
  user: IQnAUser;
}

export interface IQnAProps {
  createdAt: number;
  updatedBy: string;
  createdBy: string;
  updatedByTool: string;
  createdByTool: string;
  updatedAt: number;
}

export interface IQnAUser {
  id: string;
  timestamp: number;
  type: string;
  appid: string;
  parentid: null;
  creatorid: null;
  updated: number;
  name: string;
  tags: null;
  votes: number;
  version: number;
  stored: boolean;
  indexed: boolean;
  cached: boolean;
  identifier: string;
  groups: string;
  active: boolean;
  twoFA: boolean;
  email: string;
  currency: null;
  picture: string;
  idpIdToken: null;
  idpAccessToken: null;
  idpRefreshToken: null;
  objectURI: string;
  plural: string;
  identityProvider: string;
}
export interface ICategoryResponse {
  data: ICategory[];
}

export interface ICategory {
  id: number;
  name: string;
  regionalName: IRegionalName[];
}

export interface IRegionalName {
  name: string;
  language: string;
}

export interface ICropByCategoryResponse {
  data: ICropByCategory[];
}

export interface ICropByCategory {
  id: string;
  name: string;
  alternateName?: string[];
  scientificName?: string;
  media: ICropRegistryMedia[];
  cropDetail?: ICropDetail[];
}

export interface ICropDetail {
  cropId: string;
  name: string;
  language: string;
}
export interface ICropRegistryMedia {
  type: ICropRegistryMediaType;
  mediaUrl: string;
}
export enum ICropRegistryMediaType {
  BackGroundImage = 'BackGroundImage',
  CropIconImage = 'CropIconImage',
  CropImage = 'CropImage',
}
export interface IAnimalPreferenceResponse {
  data: IAnimalPreferenceData[];
}

export interface IAnimalPreferenceData {
  id: string;
  name: string;
  languageName: string;
  mediaUrl: string;
}

export enum IPreferenceType {
  ANIMAL = 'ANIMAL',
  CROP = 'CROP',
}

export enum IGlobalSearchTab {
  STREAM = 'STREAM',
  FEED = 'FEED',
  QNA = 'QNA',
}
